export default __webpack_public_path__ + "static/media/UM.e36f41f9.svg";